import { Box, ColorOptions } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { SectionList } from 'react-native'
import { EmptyView } from '../../comps/EmptyView'
import { useLazyApiData, useStores } from '../../data/store'
import { SUBTYPES } from '../../network/api/checkEligibilityApi'
import { formatAmount, isIFrame } from '../../utils'
import { pages, windowConfig } from '../../utils/constants'
import { CCAllEMIPlans } from '../EMI/CCAllEMIPlans'
import { SavedCard } from '../EMI/SavedCard'
import { MobileProcessing } from '../PaymentProcesseing/MobileProcessing'
import { ActionButton } from './comps/ActionButton'
import { Container } from './comps/Container'
import { ListHeader } from './comps/ListHeader'
import { ListDataProps, ListItem, ListItemProps } from './comps/ListItem'

export const JioPayFinanceHub = () => {
  const [checkedItem, setCheckedItem] = React.useState<ListItemProps>({} as any)
  const navigation = useNavigation()

  const {
    savedCard,
    addPaymentMethod,
    setSubType,
    theme,
    getAllEMIList,
    emiList,
    supportedInstrument,
    isCreditCardEmiAvailable,
    isOfferApplied,
    uniqueWindowId,
    transactionAmount
  } = useStores((root) => ({
    savedCard: root?.user?.paymentMethod,
    addPaymentMethod: root.transaction.addPaymentMethod,
    setSubType: root.jioPayFinanceHub.setSubType,
    supportedInstrument: root.jioPayFinanceHub.getSupportedInstrument(),
    theme: root.config.merchantTheme,
    getAllEMIList: root.getAllEMIList,
    emiList: root.merchant.preferences.EMILList,
    isCreditCardEmiAvailable: root.jioPayFinanceHub.isCreditCardEmiAvailable,
    uniqueWindowId: root.config.uniqueWindowId,
    isOfferApplied: root.transaction.isOfferApplied,
    transactionAmount:root?.getTransactionAmount()
  }))
  const sectionList: any = useRef(null)
  const [lazyGetEMIList, { state: lazyGetEMIListState, data: lazyGetEMIListData }] = useLazyApiData(getAllEMIList)

  const { REACT_APP_ENDPOINT = '', REACT_APP_URL = '' } = process.env
  const cardList = savedCard?.filter((card: any) => card?.type === 'CREDITCARD')
  const [selectedEmiPlan, setSelectedEmiPlan] = useState({})
  const onCvvAndPlanSelected = (emiPlan: any) => {
    setSelectedEmiPlan(emiPlan)
  }
  const [showAllEmiPlans, setShowAllEmiPlans] = React.useState(false)
  const [showPaymentProcessModal, setShowPaymentProcessModal] = useState(false)
  useEffect(() => {
    if (lazyGetEMIListState === 'rejected') {
      supportedInstrument[0].data = supportedInstrument[0]?.data?.filter((item: any) => item.type !== 'credit_card')
    }
  }, [lazyGetEMIListState, supportedInstrument])

  const loadProcessingScreen = useCallback(() => {
    const loaderUrl = REACT_APP_ENDPOINT
      ? `${REACT_APP_URL}/${REACT_APP_ENDPOINT}/loader.html`
      : `${REACT_APP_URL}/loader.html`

    if (!isIFrame()) {
      window.currentChild = window
    } else {
      window.currentChild = window.open(loaderUrl, `jiopayWindow-${uniqueWindowId}`, windowConfig)
      window.currentChild?.focus()
    }
    setShowPaymentProcessModal(true)
  }, [REACT_APP_ENDPOINT, REACT_APP_URL, uniqueWindowId])

  const renderItem = useCallback(
    (data: ListDataProps) => {
      return (
        <ListItem
          data={data}
          onRadioButtonClick={(item: any, index: any) => {
            setTimeout(() => {
              sectionList?.current?.scrollToLocation({
                sectionIndex: 0,
                itemIndex: index,
              })
            }, 0)

            setCheckedItem(item)
          }}
          onViewPlanPress={() => setShowAllEmiPlans(true)}
          checkedObject={checkedItem}
        />
      )
    },
    [checkedItem],
  )

  useLayoutEffect(() => {
    if (emiList.length === 0) {
      lazyGetEMIList(isOfferApplied ? true : false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyGetEMIList, emiList])

  const renderSectionHeader = useCallback(({ section: { headerTitle } }) => {
    return <ListHeader headerTitle={headerTitle} />
  }, [])

  return (
    <Container
      style={styles.container(theme?.bodyBgColor as ColorOptions)}
      errorMessage={isOfferApplied && lazyGetEMIListData?.message}
      onRetry={() => lazyGetEMIList(true)}>
      {lazyGetEMIListState === 'pending' && <EmptyView state={lazyGetEMIListState} onRetry={() => {}} theme={theme} />}
      {lazyGetEMIListState !== 'pending' && (
        <SectionList
          ref={sectionList}
          ListHeaderComponent={
            !isOfferApplied && cardList.length > 0 && isCreditCardEmiAvailable() ? (
              <>
                <ListHeader headerTitle={'EMI ON SAVED CARDS'} />
                <SavedCard isJioFinHubDesign={true} type={'CREDITCARD'} onCvvAndPlanSelected={onCvvAndPlanSelected} />
              </>
            ) : null
          }
          sections={supportedInstrument}
          renderItem={renderItem}
          renderSectionHeader={renderSectionHeader}
        />
      )}
      {(Object.keys(checkedItem).length !== 0 || Object.keys(selectedEmiPlan).length !== 0) && (
        <Box ph={24} pv={16}>
          <ActionButton
            title={
              Object.keys(selectedEmiPlan).length !== 0 ? `Pay ₹${formatAmount(String(transactionAmount))} through EMI` : 'Continue'
            }
            onPress={() => {
              if (checkedItem?.type === 'credit_card') {
                navigation.navigate(pages.emicard as never, { schemeSubType: '00' } as never)
              } else if (checkedItem.type) {
                setSubType(SUBTYPES[checkedItem?.type])
                navigation.navigate(pages.checkEligibility as never, checkedItem?.type as never)
              } else {
                addPaymentMethod(selectedEmiPlan as any)
                loadProcessingScreen()
              }
            }}
          />
        </Box>
      )}
      {showAllEmiPlans && (
        <CCAllEMIPlans
          open={showAllEmiPlans}
          setOpen={() => {
            setShowAllEmiPlans(false)
          }}
        />
      )}

      {showPaymentProcessModal && (
        <MobileProcessing setShow={setShowPaymentProcessModal} show={showPaymentProcessModal} />
      )}
    </Container>
  )
}

const styles = {
  container: (backgroundColor: ColorOptions) => ({
    backgroundColor,
    height: '100%',
  }),
}
export const typesMappedValue: any = {
  debitCardEmi: 'Debit Card Emi',
  cardlessEmi: 'Cardless Emi',
  payLaterEmi: 'Pay Later Emi',
}
